import { faCheckCircle } from "@jewlr/pro-solid-svg-icons/faCheckCircle"
import { Box, FontAwesomeIcon } from "@jewlr/storybook/core"
import React from "react"

import { jewlr_t } from "helpers/application"

import {
  Text,
  FormWrapper,
  ButtonLink,
  InputWrapper,
  TitleContainer,
  FormTitle,
  FormContainer,
} from "../components"

const Complete = () => (
  <FormContainer>
    <TitleContainer
      alignItems={{ _: "flex-start", tablet: "center" }}
      flexDirection={{ _: "column", tablet: "row" }}
    >
      <FontAwesomeIcon
        color="greenDarker"
        fontSize="24px"
        icon={faCheckCircle}
        mb={{ _: "10px", tablet: 0 }}
        mr={{ tablet: 2 }}
      />
      <FormTitle color="greenDarker" mb="34px">
        Your {jewlr_t("terms.shipping")} address has been changed.
      </FormTitle>
    </TitleContainer>

    <FormWrapper>
      <Text>
        You have successfully updated your {jewlr_t("terms.shipping")} address.
        Please review the new confirmation email we sent to ensure your update
        has been applied.
      </Text>
      <br />
      <Text>Thank you for shopping at {sl.config.site_title}.</Text>
      <Box py={3}>
        <InputWrapper>
          <ButtonLink
            data-cy="payments-continue-shopping-btn"
            data-lc="complete"
            to="/"
          >
            Continue Shopping
          </ButtonLink>
        </InputWrapper>
      </Box>
    </FormWrapper>
  </FormContainer>
)

export default Complete
